import type {UserMessageItem} from '../../../types/events'
import {UserMessageBubble} from '../UserMessageBubble'
import {isInjectedSource} from '../../../utils/command-helpers'

/**
 * Renders a user message bubble in the timeline.
 * Filters out dismissed messages, injected runtime messages (e.g. skill-* sources),
 * and messages with empty content (which would otherwise render a blank bubble).
 */
export function UserMessage({message}: {message: UserMessageItem}) {
  if (message.isDismissed) return null
  if (isInjectedSource(message.source)) return null
  if (!message.content?.trim()) return null

  return <UserMessageBubble content={message.content} />
}
